import React, { useCallback, useState, useEffect,useRef } from 'react';
import 'devextreme/data/odata/store';
import { useHistory } from 'react-router-dom';
import apiRoutes from "../assets/apiRoutes.json";
import axios from "axios";
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
  Column,
  DataGrid,
  Scrolling,
  FilterRow,
  FilterPanel,
  HeaderFilter,
  Paging,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import CustomStore from 'devextreme/data/custom_store';
import Accordion from 'devextreme-react/accordion';
import { getParameterByName, isNotEmpty } from "../services/DockDoorSchedulingService";
import { connect } from "react-redux";
import data from "../assets/apiRoutes.json";
import { handleDataGridExport } from "../common/Utils";
import { ExcelExportXmMonitorFileName, ExcelExportXmMonitorSheetName } from "../const/constants";
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import { GetFormatedDateWithTime } from '../common/Utils'
import "./dockdoor.css";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { GridLayout } from "../common/GridLayout";
import { CheckBox } from 'devextreme-react/check-box';
import { NumberBox, NumberBoxTypes } from 'devextreme-react/number-box';
import { fetchTransactionData } from './Services/XMService'
import { createTradingPartnersStore } from './Services/XMService';
import GridLayoutManager from "../gridLayoutCustomization/GridLayoutManager";
import '../common/css/searchPage.css';
const fileTypes = [
  {
    ID: 99,
    Name: 'ALL',
  },
  {
    ID: 1,
    Name: 'EDI',
  },
  {
    ID: 2,
    Name: 'ASCII',
  },

];
const fileTypesLookup = [

  {
    ID: 1,
    Name: 'EDI',
  },
  {
    ID: 2,
    Name: 'ASCII',
  },

];
const directions = [
  {
    ID: 99,
    Name: 'ALL',
  },
  {
    ID: 0,
    Name: 'Import',
  },
  {
    ID: 1,
    Name: 'Export',
  },

];
const directionsLokup = [
  {
    ID: 0,
    Name: 'Import',
  },
  {
    ID: 1,
    Name: 'Export',
  }

];
const transEdiStatuses = [
  {
    ID: 99,
    Name: 'ALL',
  },
  {
    ID: 0,
    Name: 'NotQueued',
  },
  {
    ID: 1,
    Name: 'Queued',
  },
  {
    ID: 2,
    Name: 'NotRelatedToTradePartner',
  },
  {
    ID: 3,
    Name: 'ParseError',
  },
  {
    ID: 4,
    Name: 'AskDocument',
  },
  {
    ID: 5,
    Name: 'Imported',
  },
  {
    ID: 6,
    Name: 'CommitError',
  },
  {
    ID: 7,
    Name: 'MappingError',
  }
];
const tranAllFileStatuses = [
  {
    ID: 99,
    Name: 'ALL',
  },
  { Name: 'Available', ID: 0 },
  { Name: 'Inprocess', ID: 5 },
  { Name: 'Complete', ID: 10 },
  { Name: 'Error', ID: 100 }
]
const defaultOurValues = [
  {
    rowid: 'O',
    ourvalue: 'ALL',
  }
]
const defaultTheirValues = [
  {
    rowid: 'O',
    theirvalue: 'ALL',
  }
]
const requests997 = [
  {
    ID: 'O',
    Name: 'ALL',
  }
]

const filtersBy = [
  {
    ID: 'O',
    Name: 'ALL',
  }
]
const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];
const historyTypes = [
  {
    ID: 1,
    Name: 'EDI Document'
  },
  {
    ID: 2,
    Name: 'EDI Message'
  },
  {
    ID: 3,
    Name: 'EDI FunctionalGroup'
  },
  {
    ID: 4,
    Name: 'EDI TranSet'
  }
];
const statusLookup = [
  { value: 0, text: 'Not Queued' },
  { value: 1, text: 'Queued' },
  { value: 2, text: 'Not Related To Trade Partner' },
  { value: 3, text: 'Parse Error' },
  { value: 4, text: 'Ack Document' },
  { value: 5, text: 'Imported' },
  { value: 6, text: 'Commit Error' },
  { value: 7, text: 'Mapping Error' },
];
const statusLookupControllNumber =[
  { value: 0, text: 'Available' },
  { value: 5, text: 'In Process' },
  { value: 10, text: 'Complete' },
  { value: 100, text: 'Error' },
]
const XmMonitor = (props) => {
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  const history = useHistory();
  const [fileType, setFileType] = useState(fileTypes[0]);
  const [direction, setDirection] = useState(directions[0]);
  const [historyType, setHistoryType] = useState(historyTypes[0]);
  const [ourVlaue, setOurValue] = useState([]);
  const [theirValue, setThierValue] = useState([]);
  const [ourVlaueLookup, setourVlaueLookup] = useState("ALL");
  const [theirValueLookup, setThierValueLookup] = useState("ALL");
  const [request997, setRequest997] = useState(requests997[0]);
  const [tradingPartners, setTradingPartners] = useState([]);
  const [tradingPartnerLookup, setTradingPartnerLookup] = useState("ALL");
  const [filterBy, setFilterBy] = useState(filtersBy[0]);
  const [transactionStatus, setTransactionStatus] = useState(tranAllFileStatuses[0]);
  const [tranSet, setTranSet] = useState('');
  const [maxRows, setMaxRows] = useState(10);
  const [isEdi, setEdi] = useState(true);
  const [isAsci, setAsci] = useState(true);

  const [transactionNumber, setTransactionNumber] = useState('');
  const [appointmentDate, setAppointmentDate] = useState('');
  const [delivered, setdeliveredDate] = useState('');

  let dateFrom = new Date();
  dateFrom.setDate(dateFrom.getDate() - 1);
  let dateTo=new Date().toISOString();

  const [delDateFrom, setdelDateFrom] = useState(dateFrom);
  const [delDateTo, setdelDateTo] = useState(dateTo);
  const [shipperBol, setShipperBol] = useState('');
  const [cust, setcust] = useState('');
  const [carrier, setcarrier] = useState('');
  const [cons, setCons] = useState('');
  const [consigneeAddress, setConsigneeAddress] = useState('');
  const [gridData, setGridData] = useState(null);
  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [selectedRefrenceNumber, setSelectedRefrenceNumber] = useState(false);

  const [animationDuration, setAnimationDuration] = useState(300);
  const allowedPageSizes = [10, 20, 50, 500, 1000, "all"]
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const gridKey = "c31cd077-2f74-4ea1-aab4-9a204027081a";
   const [currentLayout, setCurrentLayout]= useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
  const [dataSource, setDataSource] = useState(null);
  const [searchQuery, setSearchQuery] = useState({
    fileType: "",
    delDateFrom: "",
    delDateTo: "",
    historyType: "",
    transactionStatus: "",
    ourValue: "",
    theirValue: "",
    request997: "",
    tranSet: "",
    tradingPartnerLookup: ""
  });
  const shipViaSelectBox = React.createRef();

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${window._env_.REACT_APP_APIS}/${data.XM.GetTradingPartners}`,
        {
          headers: {
            'Content-Type': 'application/json',
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const tradPartnerDefaultValue = { rServiceprovId: 'ALL', tradepartnerName: 'ALL' };
      const updatedTradingPartners = [tradPartnerDefaultValue, ...response.data.lookups];
      setTradingPartners(updatedTradingPartners); // Assuming response.data is an array of trading partners
    } catch (err) {
      console.log(err, 'Error in loading trading partners');
    }
  };
  const fetchOurValueTheirValueData = async () => {
    try {
      const response = await axios.get(
        `${window._env_.REACT_APP_APIS}/${data.XM.GetOurTheirValues}`,
        {
          headers: {
            'Content-Type': 'application/json',
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data.length > 0) {
        // Combine default values with the response data
        setOurValue([
          ...defaultOurValues,
          ...response.data.map(item => ({ rowid: item.Rowid, ourvalue: item.ourvalue }))
        ]);
        setThierValue([
          ...defaultTheirValues,
          ...response.data.map(item => ({ ID: item.Rowid, theirvalue: item.theirvalue }))
        ]);
      } else {
        // Set default values if response data is empty
        setOurValue(defaultOurValues);
        setThierValue(defaultTheirValues);
      }

    } catch (err) {
      console.log(err, 'Error in loading fetchOurValueTheirValueData');
    }
  };
  const onRequestChanged = useCallback(
    (e) => {
      setRequest997(e.value);
    },
    [setRequest997],
  );

  const ondelDateFromChanged = useCallback(
    (e) => {
      setdelDateFrom(e.value);
    },
    [setdelDateFrom],
  );
  const ondelDateToChanged = useCallback(
    (e) => {
      setdelDateTo(e.value);
    },
    [setdelDateTo],
  );
  const onFilterByChanged = useCallback(
    (e) => {
      setFilterBy(e.value);
    },
    [setFilterBy],
  );
  const onOurValueChanged = useCallback(
    (e) => {
      setourVlaueLookup(e.value);
    },
    [setourVlaueLookup],
  );
  const onThierValueChanged = useCallback(
    (e) => {
      setThierValueLookup(e.value);
    },
    [setThierValueLookup],
  );
  const onShipperBolChanged = useCallback(
    (e) => {
      setShipperBol(e.value);
    },
    [setShipperBol],
  );
  const onDirectionChanged = useCallback(
    (e) => {
      setDirection(e.value);
    },
    [setDirection],
  );
  const onFileTypeChanged = useCallback(
    (e) => {
      if (e.value.Name === 'EDI') {
        setEdi(true);
        setAsci(false);
      }
      else if (e.value.Name === 'ASCII') {
        setAsci(true);
        setEdi(false);
      }
      else {
        setEdi(true);
        setAsci(true);
      }
      setFileType(e.value);
    },
    [],
  );
  const onHistoryTypeChanged = useCallback(
    (e) => {
      setHistoryType(e.value);
    },
    [setHistoryType],
  );
  const onTransactionStatusChanged = useCallback(
    (e) => { 
      setTransactionStatus(e.value);
    },
    [setTransactionStatus],
  );
  const onTradingPartnerChanged = useCallback(
    (e) => {
      setTradingPartnerLookup(e);
    },
    [setTradingPartnerLookup],
  );
  
  const onRefrenceNumberChanged = useCallback(
    (e) => {
      setSelectedRefrenceNumber(e.value);
    },
    [setSelectedRefrenceNumber],
  );
  const onTranSetChanged = useCallback(
    (e) => {
      setTranSet(e.value);
    },
    [setTranSet],
  );
  const onMaxRowsChanged = useCallback(
    (e) => {
      setMaxRows(e.value);
    },
    [],
  );

  const selectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => !prevStatus);
    },
    [selectedItems, setSelectedItems],
  );


  function handleReset() {
    setDirection(directions[0]);
    setFileType(fileTypes[0]);
    setTransactionStatus(transEdiStatuses[0]);
    setdelDateFrom('');
    setdelDateTo('');
    setDataSource([]);
    setTranSet('');
    setMaxRows(10);
  }

  const handleSearch = async (pageIndex, pageSize) => {
    try {
      loadGridData();
    } catch (err) {
      throw new Error('Data Loading Error' + err);
    }
  };
  const loadGridData=()=>{
    var resultData = fetchTransactionData(searchQuery, accessToken,
      fileType.ID,
      GetFormatedDateWithTime(delDateFrom),
      GetFormatedDateWithTime(delDateTo),
      historyType.Name,
      transactionStatus.ID,
      ourVlaueLookup,
      theirValueLookup,
      request997.Name,
      tranSet,
      tradingPartnerLookup,
      maxRows,
      direction.ID);
      setDataSource(resultData);
  }

  useEffect(() => {
    fetchData();
    fetchOurValueTheirValueData();
    loadGridData();
  }, []);

  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
          <Accordion
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={animationDuration}
            selectedItems={selectedItems}
            onSelectionChanged={selectionChanged}
            itemTitleRender={() => (
              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6
                      style={{
                        color: window._env_.Color2
                      }}
                    >
                     Search Filters
                    </h6>
                  </div>
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={() => handleSearch(0, 10)} text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleReset} text="Reset" />
                </Item>
              </Toolbar>
            )}
               
            itemRender={(itemProps) => (
                <div style={{ height: '165px', overflowY: 'auto' }}>
                  <div className="row">
                    <div className="col-md-3">
                      <SelectBox
                        className="light-ui-textbox"
                        displayExpr="Name"
                        dataSource={directions}
                        label="Direction"
                        value={direction}
                        onValueChanged={onDirectionChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <SelectBox
                        className="light-ui-textbox"
                        displayExpr="Name"
                        dataSource={fileTypes}
                        label="File Type"
                        value={fileType}
                        onValueChanged={onFileTypeChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <DateBox
                        className="light-ui-textbox"
                        label="Start"
                        defaultValue=''
                        type="date"
                        value={delDateFrom}
                        onValueChanged={ondelDateFromChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <DateBox
                        className="light-ui-textbox"
                        label="End"
                        defaultValue=''
                        type="date"
                        value={delDateTo}
                        onValueChanged={ondelDateToChanged}
                      />
                    </div>
                  </div>

                  {isEdi && (<div>
                    <div className="row" style={{ paddingTop: '10px' }}>
                      <div className="col-md-3">
                        <SelectBox
                          className="light-ui-textbox"
                          displayExpr="Name"
                          dataSource={historyTypes}
                          label="Type"
                          value={historyType}
                          onValueChanged={onHistoryTypeChanged}
                        />
                      </div>
                      <div className="col-md-3">
                        <SelectBox
                          className="light-ui-textbox"
                          displayExpr="Name"
                          dataSource={(direction?.Name==='Import' && fileType?.Name==='EDI')? transEdiStatuses:tranAllFileStatuses}
                          label="Status"
                          value={transactionStatus}
                          onValueChanged={onTransactionStatusChanged}
                        />
                      </div>

                      <div className="col-md-3">
                        <SelectBox
                          className="light-ui-textbox"
                          displayExpr="ourvalue"
                          dataSource={(direction?.Name==='Import' && fileType?.Name==='EDI' && historyType?.Name==='EDI TranSet')?ourVlaue:defaultOurValues}
                          label="Our Value"
                          valueExpr="ourvalue"
                          defaultValue="ALL"
                          onValueChanged={onOurValueChanged}
                        />
                      </div>
                      <div className="col-md-3">
                        <SelectBox
                          className="light-ui-textbox"
                          displayExpr="theirvalue"
                          dataSource={(direction?.Name==='Import' && fileType?.Name==='EDI' && historyType?.Name==='EDI TranSet')?theirValue:defaultTheirValues}
                          label="Their Value"
                          valueExpr="theirvalue"
                          defaultValue="ALL"
                          onValueChanged={onThierValueChanged}
                        />
                      </div>
                    </div>
                    <div className="row" style={{ paddingTop: '10px' }}>

                      <div className="col-md-3">
                        <SelectBox
                          className="light-ui-textbox"
                          displayExpr="Name"
                          dataSource={requests997}
                          label="Request 997"
                          value={request997}
                          onValueChanged={onRequestChanged}
                        />
                      </div>
                      <div className="col-md-3">
                        <TextBox
                          className="light-ui-textbox"
                          label="Transet"
                          defaultValue=""
                          style={{ width: '100%' }}
                          value={tranSet}
                          onValueChanged={onTranSetChanged}
                        />
                      </div>
                      <div className="col-md-3">

                        <SelectBox
                          className="light-ui-textbox"
                          dataSource={tradingPartners}
                          defaultValue="ALL"
                          displayExpr="tradepartnerName"
                          valueExpr="tradepartnerName"
                          label="Trade Partner"
                          onValueChange={onTradingPartnerChanged}
                        />
                      </div>
                      <div className="col-md-3">
                        <NumberBox
                          className="light-ui-textbox"
                          label="Max Rows"
                          defaultValue="10"
                          style={{ width: '100%' }}
                          value={maxRows}
                          onValueChanged={onMaxRowsChanged}
                        />
                      </div>
                    </div>
                  </div>
                  )}
                  {isAsci && (
                    <div className="row" style={{ paddingTop: '10px' }}>
                      {fileType.ID != 99 && (<div className="col-md-3">
                        <SelectBox
                          className="light-ui-textbox"
                          displayExpr="Name"
                          dataSource={tranAllFileStatuses}
                          label="Status"
                          value={transactionStatus}
                          onValueChanged={onTransactionStatusChanged}
                        />
                      </div>
                      )}
                      {/* <div className="col-md-3">
                        <SelectBox
                          className="light-ui-textbox"
                          displayExpr="Name"
                          dataSource={filtersBy}
                          label="Filter By"
                          value={filterBy}
                          onValueChanged={onFilterByChanged}
                        />
                      </div> */}
                    </div>

                  )}

                </div>

            )}
            id="accordion-container"
          />
        </div>
        <div className="search-page-grid-container">
          <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
            dataSource={dataSource}
            showBorders={true}
            className="search-page-grid"
            remoteOperations={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            hoverStateEnabled={true}
            wordWrapEnabled={false}
            columnAutoWidth={true}  // Enable automatic column width calculation
            scrolling={{ mode: "standard" }}
            searchEnabled={true}
          >
              <FilterRow visible={true} />
              <FilterPanel visible={true} />

              <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
              >
                <ColumnChooserSearch
                  enabled={true}
                  editorOptions={{ placeholder: 'Search column' }} />
              </ColumnChooser>
              <ColumnHeaderFilter />
              <Export enabled={true} allowExportSelectedData={true} />
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
                showNavigationButtons={true}
              />

              <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
              />
              <Scrolling rowRenderingMode="virtual" />
              <HeaderFilter visible={true} />

              <Scrolling mode="virtual" />
              <Column dataField="transet" caption="Transet" visible={false}/>
              <Column dataField="fileType" caption="Type" 
              lookup={{ dataSource: fileTypesLookup, valueExpr: 'ID', displayExpr: 'Name' }}
               cellRender={cellData => {
                switch (cellData.value) {
                  case 1:
                    return <span >EDI</span>;
                  case 2:
                    return <span >ASCII</span>;
                    case 99:
                      return <span >ALL</span>;
                  default:
                    return <span>{cellData.value}</span>;
                }
              }} />

              <Column dataField="controlNumber" caption="Control Number" visible={false} />
              {historyType.Name == 'EDI Document'
                && (
                  <Column
                    dataField="status"
                    caption="Status"
                    lookup={{ dataSource: statusLookupControllNumber, valueExpr: 'value', displayExpr: 'text' }}
                    cellRender={cellData => {
                      switch (cellData.value) {
                        case 0:
                          return <span style={{ color: 'green' }}>Available</span>;
                        case 5:
                          return <span style={{ color: 'orange' }}>In Process</span>;
                        case 10:
                          return <span style={{ color: 'blue' }}>Complete</span>;
                        case 100:
                          return <span style={{ color: 'red' }}>Error</span>;
                        default:
                          return <span>{cellData.value}</span>;
                      }
                    }} />
                )}

              {historyType.Name == 'EDI TranSet'
                && (
                  <Column
                    dataField="status"
                    caption="Status"
                    lookup={{ dataSource: statusLookup, valueExpr: 'value', displayExpr: 'text' }}
                    cellRender={cellData => {
                      switch (cellData.value) {
                        case 0:
                          return <span style={{ color: 'green' }}>Not Queued</span>;
                        case 1:
                          return <span style={{ color: 'orange' }}>Queued</span>;
                        case 2:
                          return <span style={{ color: 'blue' }}>Not Related To Trade Partner</span>;
                        case 3:
                          return <span style={{ color: 'red' }}>Parse Error</span>;
                        case 4:
                          return <span style={{ color: 'purple' }}>Ack Document</span>;
                        case 5:
                          return <span style={{ color: 'teal' }}>Imported</span>;
                        case 6:
                          return <span style={{ color: 'brown' }}>Commit Error</span>;
                        case 7:
                          return <span style={{ color: 'gray' }}>Mapping Error</span>;
                        default:
                          return <span>{cellData.value}</span>;
                      }
                    }}
                  />
                )}

              <Column dataField="creationDateTime" caption="Creation Time" />
              <Column dataField="lastUpdateDateTime" caption="Last Update Date Time" />
              {/* <Column dataField="creationDateTime" caption="Received Time" /> */}
              <Column dataField="filename" caption="Filename" />
              <Column dataField="tradepartnerName" caption="Trade Partner" />
              <Column dataField="direction" caption="Direction"
              lookup={{ dataSource: directionsLokup, valueExpr: 'ID', displayExpr: 'Name' }}
                cellRender={cellData => {
                  switch (cellData.value) {
                    case 0:
                      return <span>Import</span>;
                    case 1:
                      return <span>Export</span>;

                    default:
                      return <span>{cellData.value}</span>;
                  }
                }} />
              <Column dataField="response997" caption="Response997" visible={false}/>
              <Column dataField="isaSegment" caption="ISA Segment" visible={false}/>
              <Column dataField="delimiters" caption="Delimiter" visible={false}/>
              <Column dataField="groupVersion" caption="GRP Version" visible={false}/>
              <Column dataField="gsSegment" caption="GS Segment" visible={false}/>
              <Column dataField="isaCtrlNbr" caption="ISA CTRL NBR" visible={false}/>
              <Column dataField="startRec" caption="Start Rec" visible={false}/>
              <Column dataField="endRec" caption="End Rec" visible={false}/>
              {/* <Column dataField="tranStatus" caption="Tran Status" />
              <Column dataField="docStatus" caption="Doc Status" /> */}
              <Column dataField="mappingID" caption="Mapping ID" visible={false}/>
              <Column dataField="ourValue" caption="Our Value" visible={false}/>
              <Column dataField="theirValue" caption="Their Value"visible={false} />
              <Toolbar>
                <Item location="after">
                  <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
                <Item name="exportButton" />
                <Item name="columnChooserButton" />
              </Toolbar>
          </DataGrid>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(XmMonitor);
